"use client";

import RouteError from "@/components/RouteError";

export default function Error(props) {
  return (
    <RouteError
      {...props}
      title="Siden kunne ikke lastes"
      description="Prøv igjen for å hente innholdet på nytt."
    />
  );
}
